/**
 * FOLLOWER BOOST — parcours Réseau → Prestation → Pack (léger, sans dépendance).
 *  - feedback immédiat au tap/clic sur une carte réseau ou une prestation (état « sélectionné ») ;
 *  - hero produit : animations actives seulement à l'écran (.is-live), compteur « +quantité du pack »
 *    (illustration, jamais un résultat), mis à jour quand le pack change (évènement fb:pack) ;
 *  - prefers-reduced-motion : valeur finale directe, aucune boucle.
 */
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
const fmt = new Intl.NumberFormat(document.documentElement.lang || 'fr');

/* ---------- selection feedback ---------- */
function bindSelect(root = document) {
  root.querySelectorAll('a[data-fb-net]:not([data-fb-jn]), a[data-fb-svc]:not([data-fb-jn])').forEach((a) => {
    a.dataset.fbJn = '1';
    a.addEventListener('pointerdown', () => a.classList.add('is-pressed'), { passive: true });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach((ev) => a.addEventListener(ev, () => a.classList.remove('is-pressed'), { passive: true }));
    a.addEventListener('click', (e) => {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      a.parentElement?.querySelectorAll('.is-selected').forEach((x) => x.classList.remove('is-selected'));
      a.classList.add('is-selected');
    });
  });
}
// Back/forward cache: never come back to a page frozen in the "selected" state.
window.addEventListener('pageshow', (e) => {
  if (e.persisted) document.querySelectorAll('.is-selected, .is-pressed').forEach((x) => x.classList.remove('is-selected', 'is-pressed'));
});

/* ---------- product hero ---------- */
function parseQty(v) {
  const n = parseInt(String(v || '').replace(/[^\d]/g, ''), 10);
  return Number.isFinite(n) && n > 0 ? n : null;
}

function countTo(el, target) {
  if (!el) return;
  if (target == null) return;
  cancelAnimationFrame(el._fbRaf);
  if (reduce.matches) {
    el.textContent = '+' + fmt.format(target);
    return;
  }
  const dur = 1100;
  const t0 = performance.now();
  const step = (t) => {
    const k = Math.min(1, (t - t0) / dur);
    const eased = 1 - Math.pow(1 - k, 3);
    el.textContent = '+' + fmt.format(Math.round(target * eased));
    if (k < 1) el._fbRaf = requestAnimationFrame(step);
  };
  el._fbRaf = requestAnimationFrame(step);
}

function bindHero(root = document) {
  root.querySelectorAll('[data-fb-phero]:not([data-fb-jn])').forEach((hero) => {
    hero.dataset.fbJn = '1';
    const count = hero.querySelector('[data-fb-count]');
    let target = parseQty(count?.dataset.target);
    let played = false;
    if (count && target != null) count.textContent = '+' + fmt.format(target); // no-JS/static state stays exact

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          hero.classList.toggle('is-live', en.isIntersecting && !reduce.matches);
          if (en.isIntersecting && !played) {
            played = true;
            countTo(count, target);
          }
        });
      },
      { threshold: 0.25 }
    );
    io.observe(hero);

    const config = hero.closest('[data-fb-config]');
    config?.addEventListener('fb:pack', () => {
      const r = config.querySelector('[data-fb-packs] input[type="radio"]:checked');
      const q = parseQty(r?.dataset.quantity) ?? parseQty(r?.dataset.title);
      if (q == null) return;
      target = q;
      countTo(count, target);
      hero.classList.remove('is-bump');
      void hero.offsetWidth;
      hero.classList.add('is-bump');
    });
  });
}

function init(root) {
  bindSelect(root);
  bindHero(root);
}
init(document);
document.addEventListener('shopify:section:load', (e) => init(e.target));
